import React from 'react';
import { Box, Button, Text, VStack } from '@chakra-ui/react';
import logger from '../../utils/logger';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Log error using logger utility
    logger.error('Error Boundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box 
          p={8} 
          textAlign="center" 
          bg="red.50" 
          borderRadius="md" 
          border="1px" 
          borderColor="red.200"
          m={4}
        >
          <VStack spacing={4}>
            <Text fontSize="xl" fontWeight="bold" color="red.600">
              Something went wrong
            </Text>
            <Text color="red.500">
              {this.props.fallbackMessage || "An unexpected error occurred. Please try again."}
            </Text>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <Box 
                as="pre" 
                fontSize="sm" 
                bg="gray.100" 
                p={4} 
                borderRadius="md" 
                maxW="100%" 
                overflow="auto"
                textAlign="left"
              >
                {this.state.error.toString()}
                {this.state.errorInfo?.componentStack}
              </Box>
            )}
            
            <VStack spacing={2}>
              <Button 
                colorScheme="red" 
                onClick={this.handleReset}
              >
                Try Again
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.location.reload()}
              >
                Reload Page
              </Button>
            </VStack>
          </VStack>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;